<template lang="html">
<div>
  <toolbar title="Untethered Listings">
    <v-icon @click="refreshListings">refresh</v-icon>
  </toolbar>
  <v-layout column>
    <v-layout column class="mt-2">
      <v-card>
        <v-card-title>
          <v-layout row wrap align-end>
            <v-flex xs6></v-flex>
            <v-flex xs6>
              <v-text-field v-model="search" append-icon="search"
                            label="Search Listings" single-line hide-details>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :custom-filter="filterListings"
          :search="search"
          :items="listings"
          class="elevation-1"
          :rows-per-page-items="[10,20,30]">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <v-btn color="accent" class="mx-0"
                     @click="viewListingDetail(props.item.listingHumanId)">
                <v-icon size="18" color="white">visibility</v-icon>
                {{props.item.listingHumanId}}
              </v-btn>
            </td>
            <td class="text-xs-left">
              <v-flex>
                <b>From:</b>
                <span>
                {{props.item | originName}}
              </span>
              </v-flex>
              <v-flex>
                <b>To:</b>
                <span>
                {{props.item | destinationName}}
              </span>
              </v-flex>
            </td>
            <td class="text-xs-left">
              {{_.get(props.item, 'loadedMiles', 0) | normalizeDistance }}
            </td>
            <td class="text-xs-left">
              {{props.item.pickupTime | formatDate}}
            </td>
            <td class="text-xs-left">
              {{props.item.loadCount}}
            </td>
            <td class="text-xs-left">
              <span>
                {{props.item.bids.placed}} bids
                <span v-if="props.item.bids.placed > 0">
                  from {{props.item.bids.minimumBid}}
                </span>
              </span><br />
              <span>{{props.item.bids.availableLoadCount}}
              load<span v-if="props.item.bids.availableLoadCount !== 1" >s</span> still available
            </span>
            </td>
          </template>
        </v-data-table >
      </v-card>
    </v-layout>
  </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import companyNamesMixin from '@/mixins/companyNames';
import Toolbar from '@/components/Toolbar';
import API from '@/api';
import unitsOfMeasurePlugin from '../../mixins/unitsOfMeasurePlugin';

export default {
  name: 'Untethered',
  mixins: [companyNamesMixin, unitsOfMeasurePlugin],
  components: {
    Toolbar,
  },
  data: () => ({
    listings: [],
    loadingBtn: false,
    search: null,
    headers: [
      { text: 'Listing ID', sortable: false },
      { text: 'Load Route', sortable: false },
      { text: 'Loaded Distance', sortable: false },
      { text: 'Pickup Date', sortable: false },
      { text: '# of Loads', sortable: false },
      { text: 'Activity', sortable: false },
    ],
  }),
  computed: {
    _() {
      return _;
    },
    companyId() {
      return this.$route.params.id;
    },
  },
  methods: {
    filterListings(items, searchString, filter) {
      const search = searchString.toString().toLowerCase();
      return items.filter(listing =>
        filter(listing.listingHumanId, search));
    },
    viewListingDetail(listingId) {
      this.$router.push({ name: 'listing.detail', params: { id: listingId } });
    },
    async getListings() {
      try {
        const response = await API.load.untethered();
        this.listings = response.data.listings;
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      }
    },
    refreshListings() {
      this.$store.dispatch('applications/addLoading', [
        this.getListings(),
      ]);
    },
  },
  created() {
    this.refreshListings();
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Untethered.vue